export default {"src":"/_next/static/media/moment-only-logo.ceeb413a.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};